import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FascicoloGiudiziale } from '../../../models/fascicolo/fascicolo-giudiziale';

export class RiunioneRequest {
  dataRiunione: number;
  motivoRiunione: string;
  fascicoloCapofila: FascicoloGiudiziale;
  fascicoliDaRiunire: FascicoloFull[] = new Array<FascicoloFull>();
}
